(function ($) {
    $.fn.attachValidator = function (rulesConfig,prefix) {

        var form = $(this);
        if (!form.is('form'))
            form = form.parents('form:first');
        if (prefix == undefined)
            aqdAttachValidator(rulesConfig, form.attr('id'));
        else
            aqdAttachValidatorPrefix(rulesConfig, form.attr('id'),prefix);
    };
    
	$.fn.validateForm = function () {

		var form = $(this);
		if (!form.is('form'))
			form = form.parents('form:first');

		return submitValidatorSave(form.attr('id'));
	};
})(jQuery);
function aqdAttachValidator(rulesConfig, formName) {
    
    var validationOptions = {
     
    errorPlacement: function (error, element) { },
      highlight: function(v, classname) {
          
        // Use AttachValidator.highlight delegate to expose 'validationFailed' event
        var validator = $("#" + formName).validate();  

        var errormessage = validator.errorMap[$(v).attr('name')];
        var event = $.Event("validationFailed");
  			if ($(v).attr('linked') != undefined && $(v).attr('linked') != null && $(v).attr('linked').length > 0) 
  				v = $('#' + $(v).attr('linked'));
  			if ($(v).parent().is(".mcdropdown"))
  			    v = $(v).parent();
          
        $(v).addClass(classname);
        $(v).attr('title', errormessage);
        $(v).trigger(event, [classname, errormessage]);
  			
        // If no handlers found, perform the default action
        if (event.isDefaultPrevented()) { }
      },

      unhighlight: function(v, errorclass) {
        // Use AttachValidator.highlight delegate to expose 'validationFailed' event
        var event = $.Event("validationPassed");
  			if ($(v).attr('linked') != undefined && $(v).attr('linked') != null && $(v).attr('linked').length > 0)
  				v = $('#' + $(v).attr('linked'));
  			if ($(v).parent().is(".mcdropdown"))
  				v = $(v).parent();
        $(v).trigger(event, [errorclass]);
        // If no handlers found, perform the default action

  				$(v).removeClass(errorclass);
  				$(v).attr('title', '');
  			
  		}
  	};

  //attach the validators to everything
  	if (rulesConfig != undefined) {
  		
  		xVal.AttachValidator('', rulesConfig, null, validationOptions,formName);
  	} else {
			// No rules, just mark for validation
  	xVal.Plugins["jquery.validate"]._ensureFormIsMarkedForValidation($('#' + formName), validationOptions);
  	}
  }

  function aqdAttachValidatorPrefix(rulesConfig, formName, prefix) {
    //attach the validators to everything
    if (rulesConfig != undefined) {

        xVal.AttachValidator(prefix, rulesConfig, null, {
            ignore: ".skip-validation",
    		errorPlacement: function (error, element) { },
    		highlight: function (v, classname) {

    			// Use AttachValidator.highlight delegate to expose 'validationFailed' event
    			var validator = $("#" + formName).validate();
        var errormessage = validator.errorMap[$(v).attr('name')];
        var event = $.Event("validationFailed");
    			if ($(v).attr('linked') != undefined && $(v).attr('linked') != null && $(v).attr('linked').length > 0)
    				v = $('#' + $(v).attr('linked'));
    			if ($(v).parent().is(".mcdropdown"))
    				v = $(v).parent();
        $(v).addClass(classname);
        $(v).attr('title', errormessage);
        $(v).trigger(event, [classname, errormessage]);
        // If no handlers found, perform the default action
        if (event.isDefaultPrevented()) { }
      },
      unhighlight: function(v, errorclass) {
        // Use AttachValidator.highlight delegate to expose 'validationFailed' event
        var event = $.Event("validationPassed");
    			if ($(v).attr('linked') != undefined && $(v).attr('linked') != null && $(v).attr('linked').length > 0)
    				v = $('#' + $(v).attr('linked'));
    			if ($(v).parent().is(".mcdropdown"))
    				v = $(v).parent();
        $(v).trigger(event, [errorclass]);
        // If no handlers found, perform the default action

        $(v).removeClass(errorclass);
        $(v).attr('title', '');
      }
    },formName);      
    }
  }

  function submitValidatorSave(formName, disableFocus) {
      //validate the form
      if (disableFocus == undefined)
          disableFocus = false;
      var validator = $("#" + formName).validate();
      validator.settings.focusInvalid = !disableFocus;
    $("#" + formName).trigger("submit");
    
    var errorMessages = "<br />";
    for (var err in validator.errorList) {
      errorMessages = errorMessages + validator.errorList[err].message + "<br />";
    }

    if (validator.errorList.length > 0) {
        var text = $.dictionary.getValue("followingErrors") + "<br />" + errorMessages;
        $.errorDialog(text, $.dictionary.getValue("validationFailed"), function () {
        $(this).remove();
      });
    }

    return !validator.errorList.length > 0;
  }

  //Handle Server side validations
  function DisplayServerErrors(errors, title, introText, okFunction) {
    var errorString = introText + "<br />";

    for (var d in errors) {
      errorString = errorString + " - " + errors[d].Error + "<br />";
    }

    $.errorDialog(errorString, title, okFunction );
  }

  //Handle Server side validations
  function DisplayServerWarnings(confirmations, title, introText, confirmFunction, cancelFunction) {
    var cString = "";
    
    for (var d in confirmations) {
      cString = cString + confirmations[d].PropertyValue + "<br />";
    }

    if (cString.length > 0) {
      $.confirmDialog(cString, title, confirmFunction, cancelFunction);
    }
  }

  function DisplayServerConfirmationsWithCancel(confirmations, title, introText, yesFunction, noFunction, cancelFunction) {
    var cString = "";

    for (var d in confirmations) {
      cString = cString + confirmations[d].PropertyValue + "<br />";
    }

    if (cString.length > 0) {
      $.yesNoCancelDialog(cString, title, yesFunction, noFunction, cancelFunction);
    }
  }

   function HandleServerAjaxResponseMessage(event, title, intro) {
     var json = event.responseText;
     var returnVal = eval("(" + json + ")");

     if (returnVal.Successfull == true) {
       return true;
     }
     else {
       DisplayServerErrors(returnVal.Errors, title, intro);
       return false;
     }
   }

   function bindCaptcha(formId, captchaField) {
     $("#" + formId + " .withCapcha").hide();
     $(captchaField).val("?");
     $("#" + formId + " #IncludeRestrictedFields").change(function () {
       if ($(this).is(':checked')) {
         $("#" + formId + " #printOptions_IncludeRestrictedFields").val("true");
         $("#" + formId + " .withCapcha").show();         
         $(captchaField).val("");
       } else {
         $("#" + formId + " .withCapcha").hide();
         $("#" + formId + " #printOptions_IncludeRestrictedFields").val("false");
         $(captchaField).val("?");
       }
     });
     $("#" + formId + " #Email").change(function () {
       if ($(this).is(':checked')) {
         $("#" + formId + " #printOptions_Email").val("true");
       } else {
         $("#" + formId + " #printOptions_Email").val("false");
       }
     });
   }
   
   function checkCaptcha(continueFunction, checkVal, prefix, url, errorHeader) {
     if (checkVal != "?") {
       if (checkVal.length == 0) {
         checkVal = "-1";
       }
       var chkData;
       $.ajax({
         url: url,
         data: { prefix: prefix, checkValue: checkVal },
         async: false,
         success: function (data) { chkData = data; }
       });
       handleCaptchaCheck(chkData, errorHeader, continueFunction);
     }
     else {
       continueFunction();
     }
   }

   function handleCaptchaCheck(data, errorHeader, continueFunction) {
     if (data.Successfull) {
       continueFunction();
     } else {
       if (data.Errors.length > 0) {
         DisplayServerErrors(data.Errors, errorHeader, '');
       }
     }
   }
   
   $(document).ready(function() {
   	function addRequiredCSS(el) {
   		$(el).addClass('required');
   	    
   		// Is mcdropdown??
   		$(el).parents('.mcdropdown:first').addClass('required');
   		var forEl = $(el).attr('linked');
   	    if (forEl == undefined || forEl =='')
   	        forEl = $(el).attr('linkedto');
   		if (forEl != undefined && forEl != "") {

   			addRequiredCSS($(document.getElementById(forEl)));
   		}
   	}
   	// override the required function!
   	if (jQuery.fn.mcDropdownBase == undefined) {
   		jQuery.fn.mcDropdownBase = jQuery.fn.mcDropdown;
   		jQuery.fn.mcDropdown = function() {
   			var req = $(this).is('.required');
   			var result = jQuery.fn.mcDropdownBase.apply(this, arguments);
   			if (req) {
   				addRequiredCSS($(this));
   			}
   			return result;
   		};
   	}
   	if (jQuery.fn.rulesBase == undefined) {
   		jQuery.fn.rulesBase = jQuery.fn.rules;
   		jQuery.fn.rules = function(cmd, options) {
   		    
   			if (cmd == "add" && options != undefined && (options === "required" || options["required"] != undefined)) {
   				addRequiredCSS($(this));

   			}

   			return jQuery.fn.rulesBase.apply(this, arguments);
   		};
   	}
   	
   	
   	delete $.validator.classRuleSettings.required;
   });
  

 
